import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Button} from "@pg-design/button";
import {
    calculateRemSize,
    flex,
    flexAlignCenter,
    flexJustifyCenter,
    mb,
    onDesktop,
    p,
    pl,
    w100
} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

import {flexGap} from "../../../components/css_helpers/flex";

interface IPrice {
    price: string;
    primaryButton?: {
        text: string;
        href: string;
    };
    secondaryButton?: {
        text: string;
        href: string;
    };
    isMonitoring?: boolean;
    isFLTR?: boolean;
}

export const Price = ({price, primaryButton, secondaryButton, isMonitoring = false, isFLTR = false}: IPrice) => {
    const {t} = useTranslation();

    return (
        <div css={wrapper}>
            <div css={priceText}>
                <Text variant="headline_1" as="span">
                    {isFLTR && t("pricing.from")} {price} {t("common.pln")}
                </Text>
                <Text variant="info_txt_1" as="span" css={[pl(1), mb(1)]}>
                    / {isMonitoring ? t("pricing.report_no_vat") : `${t("pricing.month")}${t("pricing.no_vat")}`}{" "}
                </Text>
            </div>

            {(primaryButton || secondaryButton) && (
                <div css={buttonsWrapper}>
                    {primaryButton && (
                        <Button css={button} size="small" variant="filled_primary" href={primaryButton.href}>
                            <Text variant="button_small">{primaryButton.text}</Text>
                        </Button>
                    )}
                    {secondaryButton && (
                        <Button css={button} size="small" variant="outlined_secondary" href={secondaryButton.href}>
                            <Text variant="button_small">{secondaryButton.text}</Text>
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const minHeight = css`
    min-height: 62px;

    ${w100};

    ${onDesktop(css`
        min-height: 228px;
    `)}
`;

const wrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${flexGap(2)};
    ${minHeight};
    ${p(3)};
    ${flexAlignCenter};
    ${flexJustifyCenter};
`;

const priceText = css`
    ${flex("center", "center")};
`;

const buttonsWrapper = css`
    ${flex("center", "center")};
    ${flexGap(2)}
    flex-wrap: wrap;
`;

const button = css`
    width: ${calculateRemSize(24)};
`;
